import { MutationHandlingServiceV2 } from '@akebono/core';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  Output,
} from '@angular/core';
import { of, Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';

import {
  LotSettingsUpdateGQL,
  LotSource,
  LotTypeEnum,
  UserLotQuery,
} from '../../graphql/service/graphql-auto-main-service';

@Component({
  selector: 'app-lot-hide-translations-button',
  templateUrl: './lot-hide-translations-button.component.html',
  styleUrls: ['./lot-hide-translations-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotHideTranslationsButtonComponent implements OnChanges, OnDestroy {
  @Input() savedLot: UserLotQuery['lot'];
  @Input() lotType: LotTypeEnum;
  @Input() lotSource: LotSource;
  @Input() hasTranslations: boolean;
  @Input() fullSize = false;
  @Output() actionCompleted = new EventEmitter<void>();

  loading$ = of(false);

  @HostBinding('style.display')
  display: 'none' | 'inline-block' = 'none';

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly mhs: MutationHandlingServiceV2,
    private readonly lotSettingsUpdateGQL: LotSettingsUpdateGQL,
  ) {}

  get isTranslationsHidden(): boolean {
    return !!this.savedLot?.lotSetting?.translationsHidden;
  }

  toggleHideTranslations(): void {
    const mutationRef = this.mhs.mutate(this.lotSettingsUpdateGQL, {
      input: {
        lotId: this.savedLot.id,
        lotType: this.lotType,
        lotSource: this.lotSource,
        translationsHidden: !this.isTranslationsHidden,
      },
    });

    this.loading$ = mutationRef.loading;
    mutationRef.data
      .pipe(first(), takeUntil(this.destroy$))
      .subscribe(() => this.actionCompleted.emit());
  }

  ngOnChanges(): void {
    const authorized = this.savedLot?.canToggleTranslationsHidden;
    const hasTranslations = this.hasTranslations;

    this.display = authorized && hasTranslations ? 'inline-block' : 'none';
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
